import Pair from "./Pair"

class BankerPair extends Pair {

}

export default BankerPair
